
// Security utilities for input sanitization and validation
export const sanitizeInput = (input: string): string => {
  return input
    .replace(/[<>]/g, '') // Remove potential HTML tags
    .replace(/javascript:/gi, '') // Remove javascript: protocols
    .replace(/on\w+=/gi, '') // Remove event handlers
    .trim();
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) && email.length <= 255;
};

export const validatePassword = (password: string): boolean => {
  return password.length >= 8 && password.length <= 128;
};

export const validateName = (name: string): boolean => {
  return name.length >= 1 && name.length <= 100 && /^[a-zA-Z\s'-]+$/.test(name);
};

export const sanitizeAndValidate = (input: string, type: 'email' | 'password' | 'name' | 'text'): { isValid: boolean; sanitized: string } => {
  const sanitized = sanitizeInput(input);
  
  let isValid = false;
  switch (type) {
    case 'email':
      isValid = validateEmail(sanitized);
      break;
    case 'password':
      isValid = validatePassword(sanitized);
      break;
    case 'name':
      isValid = validateName(sanitized);
      break;
    case 'text':
      isValid = sanitized.length <= 1000;
      break;
  }
  
  return { isValid, sanitized };
};

// Escape HTML entities for safe rendering
export const escapeHtml = (text: string): string => {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

// Generate secure random tokens
export const generateSecureToken = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};
